/**
 * Build the unified color entries list the filter sidebar renders.
 * Merges swatch entries (with hex codes) with legacy colorFamily-only
 * entries from the API filter response, deduped by colorFamily+hexCode
 * for swatches and by colorFamily for legacy colors.
 *
 * Shared by V2CollectionProducts, Shop and DiscoverProducts so the
 * dedupe rules stay in one place.
 */
export function buildColorEntries(opts) {
  const entries = []
  const seen = new Set()
  if (Array.isArray(opts?.colorSwatches)) {
    opts.colorSwatches.forEach(s => {
      if (!s?.colorFamily) return
      const key = `${s.colorFamily}-${s.hexCode || ''}`
      if (seen.has(key)) return
      seen.add(key)
      entries.push({ colorFamily: s.colorFamily, hexCode: s.hexCode || null })
    })
  }
  if (Array.isArray(opts?.colors)) {
    opts.colors.forEach(color => {
      if (!color) return
      if (entries.some(e => e.colorFamily === color)) return
      entries.push({ colorFamily: color, hexCode: null })
    })
  }
  return entries
}
